import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-stop-page',
  templateUrl: './stop-page.component.html',
  styleUrls: ['./stop-page.component.scss']
})
export class StopPageComponent implements OnInit {
  public type: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) { }

  async ngOnInit(): Promise<void> {
    this.type = this.activatedRoute.snapshot.paramMap.get('type');
  }

  back(): void {
    this.router.navigateByUrl('/login');
  }
}
